export default __webpack_public_path__ + "/dist/images/graph1.2210b73e6e6008d93469ea90027b9291.png";